import type { HeroSliderGlobalSettingProps } from 'hb-builder/components/BuilderComponents/block/HeroSlider/Settings/Style';
import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import HorizontalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/HorizontalAlignment';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import Padding from 'hb-builder/components/common/SettingsLibrary/CommonSettings/Padding';
import SectionHeight from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SectionHeight';
import VerticalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/VerticalAlignment';
import type { OnChangeSettingsArgs } from 'hb-builder/types/settings';

const HeroSliderGlobalSetting = ({
  item,
  onChange,
  permissions,
}: HeroSliderGlobalSettingProps) => {
  const { can } = permissions || {};
  const firstTextElement = item.children[0].children[0];

  const allChildrenIds = item.children
    // slide.children is systematically an array of 3 elements: [headline, subline, button]
    .map((slide) => slide.children!.map((child) => child.id))
    .flat();

  const allSlidesIds = item.children.map((slide) => slide.id);

  const allChildrenOnChange = ({ settingKey, values, value }) =>
    onChange({ ids: allChildrenIds, settingKey, values, value });

  const slidesOnChange = ({
    settingKey,
    values,
    value,
  }: OnChangeSettingsArgs) => {
    onChange({ ids: allSlidesIds, settingKey, values, value });
  };

  const enableRoundedCorner =
    can?.canHaveRoundedCorner && !item.attributes?.outsideGrid;

  return (
    <>
      <Padding
        settingKey="containerPadding"
        title={__('Padding (in pixels)')}
        item={item.children[0]}
        onChange={slidesOnChange}
      />
      <HorizontalAlignment
        item={firstTextElement}
        onChange={allChildrenOnChange}
        title={__('Horizontal alignment')}
      />
      <VerticalAlignment item={item.children[0]} onChange={slidesOnChange} />
      <CheckboxSetting
        settingKey="outsideGrid"
        title={__('Full width')}
        item={item}
        onChange={onChange}
      />

      {enableRoundedCorner && (
        <NumberSetting
          settingKey="cornerRadius"
          title={__('Rounded corner')}
          item={item}
          onChange={onChange}
        />
      )}
      <SectionHeight item={item} onChange={onChange} />
    </>
  );
};

export default HeroSliderGlobalSetting;
